<template>
    <div class="container py-4 h-full flex justify-center items-center">
        <div class="w-full max-w-md">
            <h1 class="my-4 text-xl">{{ title }}</h1>
            <slot/>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title: String,
    }
};

</script>
